import { Directive, ElementRef, HostListener, Input, OnChanges, OnInit, Renderer2, booleanAttribute, inject } from '@angular/core';

import { injectIsRobot } from '@frontend/sports/common/ui/shared';

export type NavigationData = { url: string };

@Directive({
    selector: '[msLink]',
    standalone: true,
})
export class LinkDirective implements OnInit, OnChanges {
    @Input({ required: true }) msLink: string | undefined;
    @Input({ transform: booleanAttribute }) disabled = false;

    readonly renderer = inject(Renderer2);
    readonly element = inject(ElementRef);
    private readonly isRobot = injectIsRobot();
    nativeElement = this.element.nativeElement as HTMLElement | null;

    ngOnInit(): void {
        const tagName = this.nativeElement?.tagName.toLowerCase();
        if (tagName !== 'a') {
            throw new Error('[msLink] can only be used with an anchor tag');
        }
    }

    ngOnChanges() {
        this.updateAnchorLink();
    }

    @HostListener('click')
    onClick(event: Event) {
        if (this.disabled) {
            return false;
        }

        if (this.isRobot) {
            event.stopPropagation();
            return true;
        }
        return false;
    }

    updateAnchorLink() {
        if (!this.isRobot) {
            return;
        }

        if (this.msLink) {
            this.renderer.setAttribute(this.nativeElement, 'href', this.msLink);
        } else {
            this.renderer.removeAttribute(this.nativeElement, 'href');
        }
    }
}
